import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = {
  key: 0,
  class: "fa fa-check text-success ms-1"
}
const _hoisted_4 = { class: "mb-1 d-flex align-items-center" }
const _hoisted_5 = { class: "fw-bold me-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-secondary me-2"
}
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "fa fa-check text-success ms-1"
}
const _hoisted_9 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_10 = { class: "fw-bold me-1" }
const _hoisted_11 = {
  key: 0,
  class: "text-secondary me-2"
}

import { ref, onMounted } from 'vue';
import { BAlert, BButton, BButtonGroup } from 'bootstrap-vue-next';
import { useUserStore } from '@/store/user';
import router from '@/router';
import { formatDateTime } from '@/utils/date-utils';
import UserMfaDelete from '@/components/user/UserMfaDelete.vue';
import { MFAItem, KCCredentialDescriptor } from '@/types/auth-user';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMfa',
  setup(__props) {

const userStore = useUserStore();

// --- Local state  --
const mfaPassword = ref<MFAItem | null>(null);
const mfaTotp = ref<MFAItem | null>(null);
const mfaWebAuthns = ref<MFAItem[]>([]);

const credentials = ref<KCCredentialDescriptor[]>([]);

// Loading and Error States
const mfaFetchInProgress = ref(false);
const mfaFetchError = ref<string | null>(null);
const mfaToDelete = ref<MFAItem | null>(null);

// --- Delete MFA Credential ---
function credentialDeleteRequested(cred: MFAItem) {
  mfaToDelete.value = cred;
}

// --- RE-FETCH DATA WHEN VIEW ACTIVATED ---
async function refetchCredentials() {
  mfaToDelete.value = null;
  mfaFetchInProgress.value = true;
  mfaFetchError.value = null;

  try {
    credentials.value = await userStore.fetchUserCredentials();
    credentials.value.forEach((row) => {
      // password
      if (row.type === 'password') {
        if (row.userCredentialMetadatas.length > 0) {
          const c = row.userCredentialMetadatas[0].credential;
          mfaPassword.value = {
            kind: 'password',
            id: c.id,
            label: 'Password',
            createdAt: c.createdDate ? new Date(c.createdDate) : undefined,
            removeable: row.removeable,
            category: row.category,
          };
        } else {
          mfaPassword.value = null; // should not happen
        }
      }
      // totp
      else if (row.type === 'otp') {
        if (row.userCredentialMetadatas.length > 0) {
          const c = row.userCredentialMetadatas[0].credential;
          mfaTotp.value = {
            kind: 'otp',
            id: c.id,
            label: c.userLabel ?? 'Authenticator App',
            createdAt: c.createdDate ? new Date(c.createdDate) : undefined,
            removeable: row.removeable,
            category: row.category,
          };
        } else {
          mfaTotp.value = null;
        }
      }
      // webauthn
      else if (row.type === 'webauthn') {
        mfaWebAuthns.value = row.userCredentialMetadatas.map((meta) => {
          const c = meta.credential;
          return {
            kind: 'webauthn',
            id: c.id,
            label: c.userLabel ?? 'Security Key',
            createdAt: c.createdDate ? new Date(c.createdDate) : undefined,
            removeable: row.removeable,
            category: row.category,
          };
        });
      }
    });

    console.debug('User credentials:', credentials.value);
  } catch (err) {
    console.error('Error fetching credentials:', err);
    mfaFetchError.value = `Error fetching credentials: ${err}`;
  } finally {
    mfaFetchInProgress.value = false;
  }

  // Redirect to /mfa if no MFA methods are configured
  if (
    process.env.VUE_APP_REQUIRED_MFA === 'true' &&
    userStore.mfaNotConfigured
  ) {
    console.debug('No MFA methods configured, redirecting to /mfa');
    router.push({ name: 'MfaSelection' });
  }
}

onMounted(() => {
  refetchCredentials();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BAlert), {
      modelValue: mfaFetchError.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mfaFetchError).value = $event)),
      variant: "danger",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Error obtaining MFA settings:", -1)),
        _createTextVNode(" " + _toDisplayString(mfaFetchError.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("h5", null, [
      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "material-symbols-outlined me-1" }, "password", -1)),
      _cache[10] || (_cache[10] = _createTextVNode(" Password ", -1)),
      (!mfaFetchInProgress.value)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass({
          fa: true,
          'fa-check': mfaPassword.value !== null,
          'text-success': mfaPassword.value !== null,
          'fa-triangle-exclamation': !mfaPassword.value,
          'text-danger': !mfaPassword.value,
          'ms-1': true,
        })
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    (mfaPassword.value && mfaPassword.value.createdAt)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Last updated: ", -1)),
          _createTextVNode(" " + _toDisplayString(_unref(formatDateTime)(mfaPassword.value.createdAt)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(BButton), {
      variant: "outline-dark",
      size: "sm",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(userStore).configureMfa('UPDATE_PASSWORD')))
    }, {
      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
        _createElementVNode("i", { class: "fa fa-rotate me-1" }, null, -1),
        _createTextVNode(" Update Password ", -1)
      ]))]),
      _: 1
    }),
    _createElementVNode("h5", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-key me-1" }, null, -1)),
      _cache[14] || (_cache[14] = _createTextVNode(" Passkey (WebAuthn) ", -1)),
      (!mfaFetchInProgress.value && mfaWebAuthns.value.length > 0)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("p", { class: "mb-2" }, [
      _createElementVNode("strong", null, "Recommended:"),
      _createTextVNode(" Use a security key, hardware token or built-in biometric authentication (e.g. Touch ID, Face ID) for the highest level of security and convenience. ")
    ], -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mfaWebAuthns.value, (webAuthn, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "mb-0 mt-0"
      }, [
        _createElementVNode("p", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("i", { class: "material-symbols-outlined me-1" }, "qr_code_2", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(webAuthn.label), 1),
          (webAuthn.createdAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Added on: " + _toDisplayString(_unref(formatDateTime)(webAuthn.createdAt)), 1))
            : _createCommentVNode("", true),
          (webAuthn.removeable)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 1,
                variant: "outline-danger",
                size: "sm",
                class: "py-0 px-1",
                onClick: ($event: any) => (credentialDeleteRequested(webAuthn)),
                disabled: mfaToDelete.value !== null
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                  _createTextVNode("Remove ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode(_unref(BButton), {
      id: "webauthn-button",
      variant: "outline-dark",
      class: "me-2 mb-2 mt-2",
      size: "sm",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(userStore).configureMfa('webauthn-register')))
    }, {
      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
        _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
        _createTextVNode(" Add passkey ", -1)
      ]))]),
      _: 1
    }),
    _createElementVNode("h5", _hoisted_7, [
      _cache[18] || (_cache[18] = _createElementVNode("i", { class: "material-symbols-outlined me-1" }, "lock_clock", -1)),
      _cache[19] || (_cache[19] = _createTextVNode(" Authenticator App (TOTP) ", -1)),
      (!mfaFetchInProgress.value && mfaTotp.value !== null)
        ? (_openBlock(), _createElementBlock("i", _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("p", null, [
      _createTextVNode(" Use an authenticator app (e.g. FreeOTP, Google Authenticator, Microsoft Authenticator or your password manager) to generate "),
      _createElementVNode("strong", null, "time-based one-time passwords (TOTP)"),
      _createTextVNode(" for secure access. ")
    ], -1)),
    (mfaTotp.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _cache[22] || (_cache[22] = _createElementVNode("i", { class: "material-symbols-outlined me-1" }, "qr_code_2", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(mfaTotp.value.label), 1),
          (mfaTotp.value.createdAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Added on: " + _toDisplayString(_unref(formatDateTime)(mfaTotp.value.createdAt)), 1))
            : _createCommentVNode("", true),
          _createVNode(_unref(BButtonGroup), null, {
            default: _withCtx(() => [
              _createVNode(_unref(BButton), {
                variant: "outline-dark",
                size: "sm",
                class: "py-0 px-1",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(userStore).configureMfa('CONFIGURE_TOTP')))
              }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "fa fa-rotate me-1" }, null, -1),
                  _createTextVNode(" Reset TOTP ", -1)
                ]))]),
                _: 1
              }),
              (mfaTotp.value.removeable)
                ? (_openBlock(), _createBlock(_unref(BButton), {
                    key: 0,
                    variant: "outline-danger",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (credentialDeleteRequested(mfaTotp.value))),
                    disabled: mfaToDelete.value !== null,
                    size: "sm",
                    class: "py-0 px-1"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                      _createTextVNode("Remove ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!mfaTotp.value)
      ? (_openBlock(), _createBlock(_unref(BButton), {
          key: 2,
          variant: "outline-dark",
          class: "me-2 mb-2",
          size: "sm",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(userStore).configureMfa('CONFIGURE_TOTP')))
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
            _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
            _createTextVNode(" Set TOTP ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (mfaToDelete.value)
      ? (_openBlock(), _createBlock(UserMfaDelete, {
          key: 3,
          credentialId: mfaToDelete.value.id,
          credentialLabel: mfaToDelete.value.label,
          credentialType: 
        mfaToDelete.value.kind === 'otp'
          ? 'TOTP'
          : mfaToDelete.value.kind === 'webauthn'
          ? 'Passkey'
          : mfaToDelete.value.kind
      ,
          show: mfaToDelete.value !== null,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (mfaToDelete.value = null)),
          onCloseAndRefresh: _cache[7] || (_cache[7] = ($event: any) => (refetchCredentials()))
        }, null, 8, ["credentialId", "credentialLabel", "credentialType", "show"]))
      : _createCommentVNode("", true)
  ]))
}
}

})